// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2wu49","resendInfoText":"OnGoingPaymentBox_resendInfoText__1koKH"};